(() => {
  const closeCheckoutDrawer = (control) => {
    if (!(control instanceof Element) || control.name !== 'checkout') return;
    const drawer = control.closest('cart-drawer[open]');
    if (!drawer || typeof drawer.hide !== 'function') return;
    drawer.hide();
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    closeCheckoutDrawer(event.target.closest('button[name="checkout"], input[name="checkout"]'));
  }, true);

  document.addEventListener('submit', (event) => {
    closeCheckoutDrawer(event.submitter);
  }, true);
})();
